export const headers = [
  { label: "Account Number", key: "wholesaleAccount" },
  { label: "Name", key: "name" },
  { label: "Email", key: "email" },
  { label: "Amount", key: "" },
  { label: "Reference", key: "" },
  { label: "Description", key: "" },
];
